<template>
  <b-container
    fluid
  >
    <div class="d-flex justify-content-end mb-0 pb-0">
      <b-breadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <b-container fluid>
      <b-row>

        <b-col
          cols="12"
          class="px-1"
        >
          <b-form-group
            label="Search"
            label-for="filter_payment_nature"
            label-class="font-weight-bolder"
          >
            <b-input
              id="filter_payment_nature"
              v-model="tablePaymentNature.filter.search"
              type="text"
              placeholder="search here"
              debounce="1000"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          class="px-1 mb-2"
        >
          <b-button
            size="sm"
            type="button"
            variant="success"
            @click="onCreatePaymentNature"
          >
            Add Payment Nature
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col
          cols="12"
          class="px-1"
        >
          <b-table
            ref="tablePaymentNature"
            hover
            small
            striped
            bordered
            responsive
            show-empty
            :stacked="isMobile()"
            :per-page="tablePaymentNature.perPage"
            :current-page="tablePaymentNature.currentPage"
            :items="tablePaymentNatureProvider"
            :fields="tablePaymentNature.fields"
            :sort-by.sync="tablePaymentNature.sortBy"
            :sort-desc.sync="tablePaymentNature.sortDesc"
            :sort-direction="tablePaymentNature.sortDirection"
            :filter="tablePaymentNature.filter"
            :filter-included-fields="tablePaymentNature.filterOn"
            :busy="tablePaymentNature.busy"
          >
            <template #cell(index)="row">
              {{ tablePaymentNature.currentPage * tablePaymentNature.perPage - tablePaymentNature.perPage + (row.index + 1) }}
            </template>

            <template #cell(active)="row">
              {{ Number(row.value) === 1 ? 'Yes' : 'No' }}
            </template>

            <template #cell()="row">
              <div class="text-md-nowrap">
                {{ row.value }}
              </div>
            </template>

            <template #cell(action)="row">
              <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
                <b-button
                  size="sm"
                  variant="success"
                  @click="onEditPaymentNature(row.item)"
                >
                  Edit
                </b-button>
              </div>
            </template>

            <template #table-busy>
              <div class="text-center py-5">
                <b-icon
                  icon="stopwatch"
                  font-scale="5"
                  animation="cylon"
                />
                <p class="h3 py-2">
                  <strong>Loading . . .</strong>
                </p>
              </div>
            </template>

          </b-table>
        </b-col>

        <b-col
          cols="12"
          md="6"
          class="mt-1 mb-2 px-1"
        >
          <b-select
            v-model="tablePaymentNature.perPage"
            :options="tablePaymentNature.pageOptions"
            class="w-100 w-md-25"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex justify-content-center justify-content-md-end mt-1 px-1"
        >
          <b-pagination
            v-model="tablePaymentNature.currentPage"
            pills
            last-number
            first-number
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
            :total-rows="tablePaymentNature.totalRows"
            :per-page="tablePaymentNature.perPage"
          />
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      id="modal-payment-nature"
      scrollable
      no-close-on-esc
      no-enforce-focus
      hide-header-close
      no-close-on-backdrop
      :title="ModalPaymentNatureTitle"
    >
      <ValidationObserver
        ref="formPaymentNature"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <b-row>
            <b-col
              cols="12"
            >
              <ValidationProvider
                #default="{ errors }"
                name="nature name"
                vid="nature_name"
                rules="required|max:255"
              >
                <b-form-group
                  label="Nature Name"
                  label-for="nature_name"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <b-input
                    id="nature_name"
                    v-model="paymentNature.nature_name"
                    type="text"
                    autocomplete="off"
                    maxlength="255"
                    placeholder="enter nature name here"
                    :state="errors.length > 0 ? false : null"
                    :disabled="state.busy"
                  />
                  <div
                    v-if="errors.length > 0"
                    class="invalid-feedback"
                  >
                    <span>{{ errors[0] }}</span>
                  </div>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col
              v-if="state.editing"
              cols="12"
            >
              <b-form-group>
                <b-form-checkbox
                  id="is_active"
                  v-model="paymentNature.active"
                  switch
                  value="1"
                  name="is_active"
                  unchecked-value="0"
                  :disabled="state.busy"
                >
                  Is Active?
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </form>
      </ValidationObserver>

      <template #modal-footer="{cancel}">
        <b-button
          variant="success"
          :disabled="state.busy"
          @click="onValidatePaymentNature"
        >
          {{ state.editing ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="outline-dark"
          :disabled="state.busy"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>

<script>
import QUERY from 'lodash'
import { core } from '@/config/pluginInit'

import formatter from '@/mixins/formatter'
import misc from '@/mixins/misc'

import { STAPaymentNature } from '@/services'

export default {
  name: 'TaMaintenancesPaymentNatures',

  middleware: ['auth', 'ta'],

  mixins: [misc, formatter],

  metaInfo: () => ({
    title: 'Payment Natures'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      paymentNature: {
        id: null,
        nature_name: null,
        active: 1
      },
      tablePaymentNature: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: {
          search: null
        },
        filterOn: [],
        busy: false,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 5, key: 'action', class: 'text-center' },
          { mobile: 1, key: 'created_at', formatter: this.dateTimeShortFormatter, sortable: true },
          { mobile: 2, key: 'nature_name', label: 'payment nature' },
          { mobile: 3, key: 'active', class: 'text-center' },
          { mobile: 4, key: 'updated_at', formatter: this.dateTimeShortFormatter, sortable: true }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ModalPaymentNatureTitle () {
      return this.state.editing ? 'Edit Payment Nature' : 'Add Payment Nature'
    }
  },

  mounted () {
    core.index()
  },

  methods: {
    async tablePaymentNatureProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tablePaymentNature.busy = true
      return await STAPaymentNature.get(
        this.objectToUrl({
          page: currentPage,
          per_page: perPage,
          sort: sortBy,
          sort_desc: sortDesc,
          filter_text: filter.search
        })
      ).then(({ data }) => {
        this.tablePaymentNature.totalRows = data.total_rows
        return data.items
      }).catch(() => []).finally(() => {
        this.tablePaymentNature.busy = false
      })
    },

    onCreatePaymentNature () {
      this.state.editing = false
      this.paymentNature.id = null
      this.paymentNature.nature_name = null
      this.paymentNature.active = 1
      this.$bvModal.show('modal-payment-nature')
    },

    onEditPaymentNature (paymentNature) {
      this.state.editing = true
      this.paymentNature.id = paymentNature.id
      this.paymentNature.nature_name = paymentNature.nature_name
      this.paymentNature.active = paymentNature.active
      this.$bvModal.show('modal-payment-nature')
    },

    async onValidatePaymentNature (event) {
      event.preventDefault()
      await this.$refs.formPaymentNature.validate().then(
        async allFieldsAreValid => {
          if (allFieldsAreValid) {
            this.swalConfirm({
              html: () => {
                if (this.state.editing) {
                  return '<h6>Save your Changes on this Payment Nature?</h6>'
                }
                return '<h6>Create this Payment Nature?</h6>'
              },
              preConfirm: () => {
                this.state.busy = true
                if (this.state.editing) {
                  return this.onPutPaymentNature()
                }
                return this.onPostPaymentNature()
              }
            })
          } else {
            this.swalInvalid()
          }
        }
      )
    },

    async onPostPaymentNature () {
      return new Promise(resolve => {
        STAPaymentNature.post(this.paymentNature).then(
          ({ data: { message } }) => {
            this.$refs.tablePaymentNature.refresh()
            this.swalSuccess(message).then(() => {
              this.$bvModal.hide('modal-payment-nature')
            })
            resolve(message)
          }
        ).catch(({ message }) => {
          this.$refs.formPaymentNature.setErrors(message)
          resolve(message)
        }).finally(() => {
          this.state.busy = false
        })
      })
    },

    async onPutPaymentNature () {
      return new Promise(resolve => {
        STAPaymentNature.put(this.paymentNature).then(
          ({ data }) => {
            const tablePaymentNatureRow = QUERY.find(this.$refs.tablePaymentNature.localItems, { id: data.payment_nature.id })
            if (tablePaymentNatureRow) {
              tablePaymentNatureRow.nature_name = data.payment_nature.nature_name
              tablePaymentNatureRow.active = data.payment_nature.active
              tablePaymentNatureRow.updated_at = data.payment_nature.updated_at
            }
            this.swalSuccess(data.message).then(() => {
              this.$bvModal.hide('modal-payment-nature')
            })
            resolve(data)
          }
        ).catch(({ message }) => {
          this.$refs.formPaymentNature.setErrors(message)
          resolve(message)
        }).finally(() => {
          this.state.busy = false
        })
      })
    }
  }
}
</script>
